import { StaticPricingTab } from './pricing-display-static.types';

export const DATA_ENHANCEMENT_SERVICES_TAB: StaticPricingTab = {
  id: 'data-enhancement-services',
  label: 'Data Enhancement Services',
  sections: [
    {
      title: 'Data Services',
      headers: [
        'Quantity From',
        'Quantity To',
        'Price Per 1,000',
        'DSF2',
        'DECEASED',
        'APT APPEND',
        'ACOA',
        '',
      ],
      rows: [
        ['1', '250,000', '$1.00', 'P', 'P', 'P', 'P', ''],
        ['250,001', '2,000,000', '$0.85', 'P', 'P', 'P', 'P', '(15% Discount)'],
        [
          '2,000,001',
          '10,000,000',
          '$0.65',
          'P',
          'P',
          'P',
          'P',
          '(35% Discount)',
        ],
      ],
      notes: [
        {
          type: 'heading',
          text: 'DSF2 – Delivery Sequence File Second Generation List Processing',
        },
        {
          type: 'paragraph',
          text: 'DSF2 processing is one of the approved methods outlined in the Domestic Mail Manual for sequencing mail pieces in walk-sequence. This could allow you to qualify for lower postage rates.',
        },
        { type: 'paragraph', text: 'Some of the other benefits include:' },
        { type: 'list-item', text: 'Identify Vacant addresses' },
        {
          type: 'list-item',
          text: 'Identify Business or Residential locations',
        },
        { type: 'list-item', text: 'Identify Seasonally occupied addresses' },
        {
          type: 'list-item',
          text: 'Identify Educational institution addresses',
        },
        {
          type: 'list-item',
          text: 'Identifies a delivery point as a curb-side mailbox or as a door-slot delivery, which allows for more targeted mailings.',
        },
        { type: 'paragraph', text: 'The DSF2 database is updated monthly' },
        { type: 'heading', text: 'Deceased List Processing' },
        {
          type: 'paragraph',
          text: 'Deceased suppression will save you money and reduce complaints and embarrassing phone calls.',
        },
        {
          type: 'paragraph',
          text: 'Marketing Service Providers, Print Shops and Mailers should take every measure to minimize insensitive situations caused by sending mail to deceased individuals. The comprehensive AccuZIP Deceased List Processing service will reduce the number of deceased records in your mail files.',
        },
        {
          type: 'paragraph',
          text: 'Even though you may know your customers very well, it is common not to know when a customer passes away. We have been asked by many customers to begin offering this valuable service. AccuZIP continues to meet the needs of our customers and is excited to offer these new data enhancement services.',
        },
        {
          type: 'paragraph',
          text: 'As with NCOALink and our other Cloud services, we process your file in real-time, as we receive them. So within minutes, you have your results and can move to the next step in your work-flow. Unlike other companies, we do not charge an additional fee for our real-time (vs. the next day) processing you sometimes get with other vendors.',
        },
        { type: 'heading', text: 'Q&A' },
        {
          type: 'list-item',
          text: 'Is the SSA DMF your main source of data? Can you provide any insight into other data sources that you leverage? – Yes, the SSA is the contents of the file',
        },
        {
          type: 'list-item',
          text: 'How many records are in your total population of deceased data? As of our last update, there are 78,638,183 records on the deceased file. We remove those that are beyond 20 years.',
        },
        {
          type: 'list-item',
          text: 'How often is your death data file updated? Monthly',
        },
        {
          type: 'list-item',
          text: 'What would you expect might be the average time that it takes for a reported death to appear in your data? Typically about 3-5 months.',
        },
        { type: 'heading', text: 'Apartment Append Processing' },
        {
          type: 'paragraph',
          text: 'Apartment Append will correct records on your file that have been identified by the DPV® process as having either incorrect or missing apartment numbers. After the candidate records are identified the Apartment Append process updates the missing or incorrect information. The database includes only DPV verified addresses and the name and address matching logic is tight. 1.2 billion mail-pieces lack complete address information',
        },
        { type: 'heading', text: 'ACOA - AccuZIP Change of Address service' },
        {
          type: 'paragraph',
          text: 'Find change-of-address (COA) information well beyond the USPS NCOALink® file with AccuZIP Change of Address enhanced service. When combined with NCOALink, the use of our ACOA service can provide 20-40% more matches than running NCOALink alone.',
        },
        {
          type: 'paragraph',
          text: "Our enhanced COA service utilizes compiled databases from retail, the nation's leading publishing companies, telecom, utility companies, credit card companies and other private sources and contains approximately 30 million records and goes back 60-months (5-years).",
        },
        {
          type: 'paragraph',
          text: 'When people move, not everyone registers their change-of-address with the United States Postal Service. Without this registration the move is not recorded in the NCOALink database, and therefore no forwarding address can be provided.',
        },
        {
          type: 'paragraph',
          text: 'By using the trusted AccuZIP Change of Address service you can search beyond the scope of our Licensed NCOALink data alone.',
        },
        {
          type: 'paragraph',
          text: 'ACOA gives you additional matches and updates your database, enabling you to stay in contact with your customers whose records might otherwise become undeliverable and lost forever.',
        },
        {
          type: 'paragraph',
          text: 'ACOA matches are performed at the individual level only to avoid false matches. This means that your full contact name and mailing address must match to the previous address record on the ACOA file before AccuZIP will consider it to be a match and therefore provide you with the new address.',
        },
        {
          type: 'paragraph',
          text: 'ACOA is not meant to replace NCOALink, but enhance it. To achieve the best results, it is highly recommended that you always process your names and addresses through our Licensed NCOALink service and our ACOA service. NCOALink is required to meet the USPS Move Update Requirements. ACOA alone cannot be used to meet the USPS Move Update Requirements.',
        },
        { type: 'paragraph', text: 'The ACOA database is updated monthly.' },
        {
          type: 'heading',
          text: 'Real-time Data Enhancement Services Processing',
        },
        {
          type: 'paragraph',
          text: 'As with NCOALink and our other Cloud services, we process your file in real-time, as we receive them. So within minutes, you have your results and can move to the next step in your work-flow. Unlike other companies, we do not charge an additional fee for our real-time (vs. the next day) processing you sometimes get with other vendors.',
        },
      ],
    },
    {
      title: 'DES BULK PRICING',
      headers: [
        'Pre-Purchased Credits',
        'Deceased, DSF2, Apt Append and ACOA (1, 2, 3, or 4 Services) per 1,000',
        'Discount',
        'Pre-Purchase ($)',
      ],
      rows: [
        ['100,000,000', '$0.65', '35.00%', '$65,000.00'],
        ['500,000,000', '$0.59', '41.50%', '$295,000.00'],
        ['1,000,000,000', '$0.52', '48.00%', '$520,000.00'],
      ],
    },
    {
      title: 'DES BULK PRICING — DSF2 Only',
      headers: [
        'Pre-Purchased Credits',
        'DSF2 Only per 1,000',
        'Discount',
        'Pre-Purchase ($)',
      ],
      rows: [
        ['100,000,000', '$0.49', '51.25%', '$48,750.00'],
        ['500,000,000', '$0.44', '56.13%', '$219,375.00'],
        ['1,000,000,000', '$0.39', '61.00%', '$390,000.00'],
      ],
    },
  ],
};
